import { chunk } from 'lodash'

export const arrayChunk = chunk
